import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AlertSheet } from '../models/alert.model';
import { AngularFirestore, CollectionReference } from '@angular/fire/compat/firestore';
import { Credentials } from '@app/auth';
import { Transaction } from '../models/transaction.model';

import {
  differenceInWeeks,
  differenceInMonths,
  differenceInDays,
  differenceInHours,
  differenceInYears,
} from 'date-fns';
import { Logger } from '../logger.service';
import { AlertComponent } from '../components/modals/alert/alert.component';

const log = new Logger('alert-service');

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private path = 'alerts';
  private collection: CollectionReference<AlertSheet>;
  constructor(private firestore: AngularFirestore, private modalCtrl: ModalController) {
    this.collection = this.firestore.collection<AlertSheet>(this.path).ref;
  }

  // Obtener todos los elementos
  private async getAllActive(): Promise<AlertSheet[]> {
    const snap = await this.collection.where('isActive', '==', true).get();
    const data = snap.docs.map((o) => {
      return { uid: o.id, ...o.data() };
    });
    return data;
  }

  // // Obtener todos los elementos
  // private async getAll(): Promise<AlertSheet[]> {
  //   const snap = await this.collection.get();
  //   const data = snap.docs.map((o) => {
  //     return { uid: o.id, ...o.data() };
  //   });
  //   return data;
  // }

  // // Obtener un elemento por ID
  // private async getById(uid: string): Promise<AlertSheet | null> {
  //   const snap = await this.collection.doc(uid).get();
  //   if (snap.exists) {
  //     const data = { uid: snap.id, ...snap.data() } as AlertSheet;
  //     return data;
  //   } else {
  //     return null;
  //   }
  // }

  async presentActionSheet(credentials: Credentials, transactions: Transaction[]) {
    const alerts = await this.getAllActive();

    if (alerts.length) {
      const now = new Date();
      const purchaseTransactions = transactions.filter((t) => t.type.includes('purchase'));

      const purchaseLoteria = purchaseTransactions.filter(
        (t) => t.type !== 'wallet-purchase-casino' && t.type !== 'wallet-purchase-book'
      );
      const purchaseCasino = purchaseTransactions.filter((t) => t.type === 'wallet-purchase-casino');
      const purchaseBook = purchaseTransactions.filter((t) => t.type === 'wallet-purchase-book');

      log.info({
        loteria: purchaseLoteria.length,
        casino: purchaseCasino.length,
        book: purchaseBook.length,
      });

      const filteredAlerts = alerts.filter((a) => {
        // filytrar por tiempo
        if (now.getTime() >= a.startAt.toMillis() && now.getTime() <= a.endAt.toMillis()) {
          if (a.rules.length) {
            let pass = false;

            for (const rule of a.rules) {
              // revisar condicion "user ID"
              if (!pass && rule.condition === 'userId' && rule.userId && rule.userId.length) {
                pass = rule.userId.some((id) => id === credentials.id);
              }

              if (!pass && rule.condition === 'lastLogin' && rule.lastLogin) {
                // condicioners para el ultimo login
                const { user } = credentials;

                if (user.lastLogin && user.actualLogin) {
                  if (rule.lastLogin.hours) {
                    const hours = differenceInHours(user.actualLogin.toDate(), user.lastLogin.toDate());
                    pass = hours >= rule.lastLogin.hours;
                  }

                  if (!pass && rule.lastLogin.days) {
                    const days = differenceInDays(user.actualLogin.toDate(), user.lastLogin.toDate());
                    pass = days >= rule.lastLogin.days;
                  }

                  if (!pass && rule.lastLogin.weeks) {
                    const weeks = differenceInWeeks(user.actualLogin.toDate(), user.lastLogin.toDate());
                    pass = weeks >= rule.lastLogin.weeks;
                  }

                  if (!pass && rule.lastLogin.months) {
                    const months = differenceInMonths(user.actualLogin.toDate(), user.lastLogin.toDate());
                    pass = months >= rule.lastLogin.months;
                  }

                  if (!pass && rule.lastLogin.years) {
                    const years = differenceInYears(user.actualLogin.toDate(), user.lastLogin.toDate());
                    pass = years >= rule.lastLogin.years;
                  }
                }
              }

              if (!pass && purchaseTransactions.length && rule.condition === 'purchase' && rule.purchase) {
                // coparar cada tipo de venta para saber que condiciones aplica y cuales no

                // condiciones para ventas con loteria y sin ventas de alguna entre casino y sporttsbook
                if (
                  rule.purchase.loteria &&
                  purchaseLoteria.length &&
                  (rule.purchase.loteria.casino || rule.purchase.loteria.sportsbook)
                ) {
                  pass =
                    typeof rule.purchase.loteria.casino === 'number' &&
                    (!purchaseCasino.length || rule.purchase.loteria.casino > purchaseCasino.length);
                  pass =
                    pass ||
                    (typeof rule.purchase.loteria.sportsbook === 'number' &&
                      (!purchaseBook.length || rule.purchase.loteria.sportsbook > purchaseBook.length));
                }

                // condiciones para ventas con casino y sin ventas de alguna entre loteria y sporttsbook
                if (
                  !pass &&
                  rule.purchase.casino &&
                  purchaseCasino.length &&
                  (rule.purchase.casino.loteria || rule.purchase.casino.sportsbook)
                ) {
                  pass =
                    typeof rule.purchase.casino.loteria === 'number' &&
                    (!purchaseLoteria.length || rule.purchase.casino.loteria > purchaseLoteria.length);
                  pass =
                    pass ||
                    (typeof rule.purchase.casino.sportsbook === 'number' &&
                      (!purchaseBook.length || rule.purchase.casino.sportsbook > purchaseBook.length));
                }

                // condiciones para ventas con casino y sin ventas de alguna entre loteria y sporttsbook
                if (
                  !pass &&
                  rule.purchase.sportsbook &&
                  purchaseBook.length &&
                  (rule.purchase.sportsbook.loteria || rule.purchase.sportsbook.casino)
                ) {
                  pass =
                    typeof rule.purchase.sportsbook.loteria === 'number' &&
                    (!purchaseLoteria.length || rule.purchase.sportsbook.loteria > purchaseLoteria.length);
                  pass =
                    pass ||
                    (typeof rule.purchase.sportsbook.casino === 'number' &&
                      (!purchaseCasino.length || rule.purchase.sportsbook.casino > purchaseCasino.length));
                }
              }
            }

            return pass;
          }
        }

        return false;
      });

      log.info(filteredAlerts);

      // mostrar las alertas
      for (const alert of filteredAlerts) {
        // const actionSheet = await this.actionSheetCtrl.create({
        //   header: alert.title,
        //   subHeader: alert.message,
        //   buttons: [
        //     ...alert.buttons.map((b) => {
        //       const { text, role, data, to } = b;

        //       const handler = () => {
        //         if (to.length) {
        //           this.navCtrl.navigateForward([to]);
        //         }
        //       };

        //       return {
        //         text,
        //         role,
        //         data,
        //         handler,
        //       };
        //     }),
        //     {
        //       text: this.translateS.instant('Close'),
        //       role: 'cancel',
        //       data: {
        //         action: 'cancel',
        //       },
        //     },
        //   ],
        // });

        // await actionSheet.present();
        const modal = await this.modalCtrl.create({
          component: AlertComponent,
          componentProps: {
            alert,
          },
          cssClass: 'alert-detail',
        });

        await modal.present();
      }
    }
  }
}
